import { BinConstraint } from '../types/bin_constraints/binConstraint';
import {
  CreateBinConstraintInput,
  DeleteBinConstraintInput,
  UpdateBinConstraintInput,
} from '../types/bin_constraints/binConstraint.input';
import { http } from '../util/https.util';
import { PaginatedResponse } from './common/paginatedResponse';

const LIST = '/api/bin_constraint/list';

const CREATE = '/api/bin_constraint/create';
const UPDATE = '/api/bin_constraint/update';
const DELETE = '/api/bin_constraint/delete';

export namespace BinConstraintRequest {
  export const list = async (payload: { page: number }): Promise<PaginatedResponse<BinConstraint>> => {
    return (await http.post(LIST, payload)).data;
  };

  export const create = async (payload: { data: CreateBinConstraintInput[] }): Promise<BinConstraint[]> => {
    return (await http.post(CREATE, payload)).data;
  };

  export const update = async (payload: { data: UpdateBinConstraintInput[] }): Promise<BinConstraint[]> => {
    return (await http.post(UPDATE, payload)).data;
  };

  export const remove = async (payload: { data: DeleteBinConstraintInput[] }): Promise<BinConstraint[]> => {
    return (await http.post(DELETE, payload)).data;
  };
}
